import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IDeleteFn, ITrainingGroup, IGetPutRequest } from '../../interfaces'

const getToggleActiveTrainingGroupMutationRequest: IGetPutRequest = params => {
  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingGroups/`,
  }
}

const useToggleActiveTrainingGroupMutation: IUseUpdateMutation<ITrainingGroup, number> = (params, options = {}) => {
  const request = useMemo(() => getToggleActiveTrainingGroupMutationRequest(params), [params])

  const updateTraining: IDeleteFn<ITrainingGroup> = useCallback(
    async id => axios({ ...request, url: request.url + id + '/toggle-is-active' }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingGroup, Error, any>({ mutationFn: updateTraining, ...options })

  return response
}

export default useToggleActiveTrainingGroupMutation
